import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAuthenticated, selectCurrentUser } from '../Login/selectors';
import Avatar from '../Avatar';
import { imageUrl } from '../services/helpers';
import { Header, Logo, Nav } from './styled';

const MainMenu = () => {
  const authenticated = useSelector(selectAuthenticated);
  const user = useSelector(selectCurrentUser);

  return (
    <Header>
      <Link to="/" aria-label="Pokémon TCG home">
        <Logo src={imageUrl('/pokemon-tcg-logo.png')} alt="Pokémon Trading Card Game" />
      </Link>
      {authenticated && (
        <Nav>
          <Link to="/cards">Cards</Link>
          <Link to="/decks">Decks</Link>
          <Link to="/rules">Rules</Link>
          <Link to="/profile" aria-label="Profile"><Avatar user={user} size={30} /></Link>
        </Nav>
      )}
    </Header>
  );
};

export default MainMenu;
